var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledheart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6.5625C21.5 13.125 11.7697 18.4369 11.3553 18.6562C11.2461 18.715 11.124 18.7458 11 18.7458C10.876 18.7458 10.7539 18.715 10.6447 18.6562C10.2303 18.4369 0.5 13.125 0.5 6.5625C0.501737 5.02146 1.11468 3.54404 2.20436 2.45436C3.29404 1.36468 4.77146 0.751737 6.3125 0.75C8.24844 0.75 9.94344 1.5825 11 2.98969C12.0566 1.5825 13.7516 0.75 15.6875 0.75C17.2285 0.751737 18.706 1.36468 19.7956 2.45436C20.8853 3.54404 21.4983 5.02146 21.5 6.5625Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledheart);
export default __webpack_public_path__ + "static/media/filledheart.b76fac97916c5e9e40ffe944e39513a8.svg";
export { ForwardRef as ReactComponent };